import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

$( '.image-carousel' ).each( function() {
	const $this = $( this );

	let swiperConfig = {
		loop: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 8,
		grabCursor: true,
		speed: 600,
	};

	var swiper = new Swiper( this, swiperConfig );

	let slidersCount = swiper.slides.length;
	let $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'left': (100 / slidersCount) * this.activeIndex + '%' } );

		let fancyboxImage = $this.find( '.swiper-slide' ).eq( swiper.realIndex ).attr( 'data-fancybox-image' );
		$this.parents( '.carousel-container' ).find( '.carousel-zoom' ).attr( 'href', fancyboxImage );
	} );
} );

$( '.properties-carousel' ).each( function() {
	const $this = $( this );

	let swiperConfig = {
		loop: false,
		slidesPerView: 1.05,
		spaceBetween: 16,
		grabCursor: true,
		speed: 600,
	};

	var swiper = new Swiper( this, swiperConfig );

	let slidersCount = swiper.slides.length;
	let $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'left': (100 / slidersCount) * this.activeIndex + '%' } );

		let fancyboxImage = $this.find( '.swiper-slide' ).eq( swiper.realIndex ).attr( 'data-fancybox-image' );
		$this.parents( '.carousel-container' ).find( '.carousel-zoom' ).attr( 'href', fancyboxImage );
	} );
} );
